import FolderCopyIcon from '@mui/icons-material/FolderCopy';
import LogoutIcon from '@mui/icons-material/Logout';
import MenuIcon from "@mui/icons-material/Menu";
import PersonIcon from '@mui/icons-material/Person';
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import WebIcon from '@mui/icons-material/Web';
import { Avatar, Badge, BadgeProps, Divider, Drawer, Icon, List, ListItem, ListItemButton, ListItemIcon, ListItemText, styled } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import IconButton from "@mui/material/IconButton";
import MenuItem from "@mui/material/MenuItem";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import ButtonToggleTheme from "@/components/Layout/ButtonToggleTheme";
import AccountMenu from "@/components/Layout/AccountMenu";
import SearchInput from "@/components/Layout/SearchInput";
import React, { useEffect, useState } from "react";
import { To, useNavigate } from "react-router-dom";
import { useAppSelector } from "@/redux/store";
import logo from '../../assets/logo_modoblanco.png';
import { useGetCartQuery } from '@/redux/api/cartApi';

const StyledBadge = styled(Badge)<BadgeProps>(({ theme }) => ({
  '& .MuiBadge-badge': {
    right: -3,
    backgroundColor: 'white',
    transition: 'transform 0.2s ease-in-out'
  },
}));

const ProfileShoppingDarkTheme = ({ user, informes, darkTheme, goToPage }: {
  user: any,
  informes: any[],
  darkTheme: boolean,
  goToPage: (url: To) => void

}) => {
  return (<>

    <ButtonToggleTheme />
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 1,
        color: 'white',
        marginLeft: 1,
        marginRight: 1,

      }}
    >
      <IconButton aria-label='cart' onClick={() => goToPage('/carrito')} id='header-carrito-main-icon-button'>
        <StyledBadge badgeContent={informes.length}
          id='header-carrito-main-badge'
          //cambiar de color el span dentro del span
          sx={{ '& .MuiBadge-badge': { color: darkTheme ? '#000' : '#000' } }}
        >
          <ShoppingBagIcon />
        </StyledBadge>
      </IconButton>
    </Box >

    {user ? <Box display='flex'>
      <Typography variant="body1" alignSelf='center' component="div" sx={{ display: { md: 'flex', xs: 'none' } }}>
        ¡Hola, {user.nombre}!
      </Typography>
      <AccountMenu user={user} />
    </Box> :

      <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>

        <Button
          onClick={() => goToPage('/login')}
          sx={{ my: 2, color: 'white', display: 'block' }}
        >
          Acceso
        </Button>
        <Button
          onClick={() => goToPage('/register')}
          sx={{ my: 2, color: 'white', display: 'block' }}
        >
          Registrarse
        </Button>
      </Box>

    }

  </>)
}

function Header() {
  const pages = [
    {
      path: '/',
      Icon: <Icon>home</Icon>,
      name: 'Inicio'
    },
    {
      path: '/precios',
      Icon: <WebIcon />,
      name: 'Precios'
    },
    {
      path: '/empresa',
      Icon: <Icon>business</Icon>,
      name: 'Empresa'
    },
    {
      path: '/contacto',
      Icon: <Icon>contact_page</Icon>,
      name: 'Contacto'
    },

  ]
  const user = useAppSelector(state => state.userState.user);
  const { data: apiCart } = useGetCartQuery()
  const informes = apiCart?.data || []

  const navigate = useNavigate()
  const [lenInforme] = useState(informes.length)

  const [anchorElNav, setAnchorElNav] = useState<null | HTMLElement>(null);

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };


  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const goToPage = (url: To) => {
    navigate(url)
    handleCloseNavMenu()
  }


  const darkTheme = useAppSelector(state => state.theme.darkTheme)

  useEffect(() => {
    //Ver si se agregó un informe y de ser asi animar el icono

    if (informes.length > lenInforme) {

    }
  }, [informes, lenInforme])


  const MyDrawer = () => {

    return <Drawer
      anchor={'left'}
      open={Boolean(anchorElNav)}
      onClose={handleCloseNavMenu}
    >


      <Box sx={{ width: '50vw', maxWidth: '300px', minWidth: '240px' }}>

        {user ? <>
          <div aria-label="profile-info" style={{ padding: '1rem' }}>

            <Avatar sx={{ width: 56, height: 56 }}
              src={user.fotoPerfil ? user.fotoPerfil : ''}
            />
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
              {user.nombre}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {user.email}
            </Typography>
          </div>
          <List>
            <ListItem disablePadding>
              <ListItemButton onClick={handleCloseNavMenu}>
                <ListItemIcon>
                  <PersonIcon />
                </ListItemIcon>
                <ListItemText primary={'Perfil'} onClick={() => navigate('/perfil')} />
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
              <ListItemButton onClick={handleCloseNavMenu}>
                <ListItemIcon>
                  <FolderCopyIcon />
                </ListItemIcon>
                <ListItemText primary={'Informes'} onClick={() => navigate('/perfil/informes')} />
              </ListItemButton>
            </ListItem>
          </List>
        </> :
          //? NO USER
          <>
            <Typography variant="h5" sx={{ padding: '1rem', textAlign: 'center' }}>
              PyM Gestiones
            </Typography>
            <List>
              <ListItem disablePadding>
                <ListItemButton onClick={() => goToPage('/login')}>
                  <ListItemIcon>
                    <PersonIcon />
                  </ListItemIcon>
                  <ListItemText primary={'Ingresar'} />
                </ListItemButton>
              </ListItem>
              <ListItem disablePadding>
                <ListItemButton onClick={() => goToPage('/register')}>
                  <ListItemIcon>
                    <LogoutIcon />
                  </ListItemIcon>
                  <ListItemText primary={'Registrarse'} />
                </ListItemButton>
              </ListItem>
            </List>
          </>}
        <Divider />
        <nav aria-label="drawer-pages ">
          <List>
            {
              pages.map((page: any, i) => (
                <ListItem disablePadding key={page + i + 'mndsapiand'} onClick={() => goToPage(page.path)}>
                  <ListItemButton>
                    <ListItemIcon>
                      {page.Icon}
                    </ListItemIcon>
                    <ListItemText primary={page.name} />
                  </ListItemButton>
                </ListItem>
              ))
            }
            {user &&
              <ListItem disablePadding onClick={() => goToPage('perfil/informes')}>
                <ListItemButton>
                  <ListItemIcon>
                    <Icon>topic</Icon>
                  </ListItemIcon>
                  <ListItemText primary={'Mis Informes'} />
                </ListItemButton>
              </ListItem>
            }
          </List>
        </nav>


      </Box>
    </Drawer>



  }




  return (
    <AppBar position="static">
      <Container maxWidth="xl">
        <Toolbar disableGutters sx={{ flexDirection: 'column', placeContent: 'center' }}>

          <Box sx={{
            display: { xs: 'none', md: 'flex' }, width: '100%', justifyContent: 'space-between',
            paddingTop: '10px'
          }}>
            <Typography
              variant="h6"
              noWrap
              component="a"
              onClick={() => goToPage('/')}
              sx={{
                color: "#fff",
                mr: 2,
                fontSize: '3ch',
                display: { xs: "none", md: "flex" },
                flexDirection: "column",
                justifyContent: "center",
                fontWeight: 700,
                textDecoration: "none",
                "&:hover": {
                  cursor: 'pointer'
                },
                paddingLeft: '17px',
              }}
            >
              <img
                src={logo}
                style={{ width: '100%', height: '3rem' }}
                alt='Angie-logo-pym'
              />
            </Typography>
            <SearchInput />

            <Box sx={{ flexGrow: 0, display: { xs: 'flex', md: 'flex' } }}>
              <ProfileShoppingDarkTheme
                user={user}
                informes={informes}
                darkTheme={darkTheme}
                goToPage={goToPage}
              />
            </Box>
          </Box>

          <Box aria-label={'mobile-box'} sx={{ display: "flex", width: "100%" }}>
            <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpenNavMenu}
                color="inherit"
              >
                <MenuIcon />
              </IconButton>

              <MyDrawer />

            </Box>
            <Typography
              variant="h5"
              noWrap
              component="a"
              href="#"
              onClick={() => goToPage("/")}
              sx={{
                mr: 2,
                display: { xs: 'flex', md: 'none' },
                flexGrow: 1,
                fontFamily: 'monospace',
                fontWeight: 700,
                letterSpacing: '.3rem',
                color: 'inherit',
                textDecoration: 'none',
                alignSelf: 'center',
              }}
            >
              𝒫𝓎𝑀
            </Typography>


            <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex', paddingBottom: '0.5rem', paddingTop: '0.3rem' } }}>
              {pages.map((page: any, i) => (
                <MenuItem key={page + i} onClick={() => goToPage(page.path)}>
                  <Typography textAlign="center" color='#FFF'>{page.name}</Typography>
                </MenuItem>

              ))}
              <MenuItem onClick={() => goToPage('perfil/informes')}>
                <Typography textAlign="center" color='#FFF'>{'Mis Informes'}</Typography>
              </MenuItem>
            </Box>


            <Box sx={{ flexGrow: 0, display: { xs: 'flex', md: 'none' } }}>
              <ProfileShoppingDarkTheme
                user={user}
                informes={informes}
                darkTheme={darkTheme}
                goToPage={goToPage}
              />
            </Box>



          </Box>



        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default Header;